module.exports = __webpack_public_path__ + "img/vip.61c00657.svg";